<template>
  <div
    class="my-[24px]"
  >
    <b-input-group class="group mb-[16px]">
      <b-input-group-append>
        <div class="flex items-center justify-center w-[40px] border-[1px] border-[#E2E2E2] rounded-l-[8px] !border-r-0 transition-colors group-focus-within:border-[#F95031]">
          <span class="k-search-normal-1 text-[20px]" />
        </div>
      </b-input-group-append>
      <b-form-input
        placeholder="Cari gudang"
        class="border-[1px] border-[#E2E2E2] rounded-r-[8px] !border-l-0 transition-colors group-focus-within:border-[#F95031]"
        @input="handleSearchWarehouse"
      />
    </b-input-group>

    <div
      v-if="isError"
      class="flex flex-col items-center justify-center gap-[8px] py-[26px] px-[8px]"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
        alt="warning"
        class="size-[40px] mb-[8px]"
      >
      <p
        class="text-[#828282] text-[14px] mb-0 text-center"
      >
        Terjadi kesalahan saat mengambil data gudang, silahkan refresh halaman untuk mencoba kembali
      </p>
    </div>

    <div
      v-if="isLoading"
      class="flex items-center justify-center gap-[8px] py-[26px] px-[8px]"
    >
      <b-spinner
        small
        variant="primary"
        label="memuat data gudang"
      />
      <p class="text-[#828282] text-[14px] mb-0 text-center">
        Memuat data gudang...
      </p>
    </div>

    <div
      v-if="cannotFindWarehouse"
      class="flex flex-col items-center justify-center gap-[8px] py-[26px] px-[8px]"
    >
      <p class="text-[#828282] text-[14px] mb-0 text-center">
        Gudang <em>'{{ searchWarehouse }}'</em> belum ditemukan. Coba gunakan kata kunci lain.
      </p>
    </div>

    <div
      class="max-h-[300px] overflow-y-auto pr-[4px] -mr-[4px]"
    >
      <card-warehouse
        v-for="(warehouse, index) in data"
        :key="generateKey(warehouse, index)"
        :selected="checkIsSelected(warehouse)"
        :data="warehouse"
        :disabled="checkIsDisabled(warehouse)"
        selection
        @click="handleCardClick(warehouse)"
      />

      <widget-load-more :fetcher="warehouseFetcher" />
    </div>
  </div>
</template>

<script>
import CardWarehouse from './CardWarehouse.vue'
import WidgetLoadMore from './WidgetLoadMore.vue'

export default {
  name: 'WidgetListWarehouse',
  components: {
    CardWarehouse,
    WidgetLoadMore,
  },
  props: {
    warehouseFetcher: {
      type: Object,
      required: false,
      default: () => null,
    },
    usedWarehouses: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      selectedWarehouse: null,
      searchWarehouse: '',
      filteredData: undefined,
    }
  },
  computed: {
    data() {
      return this.filteredData || this.warehouseFetcher?.data || []
    },
    isLoading() {
      return this.data.length === 0 && this.warehouseFetcher?.isLoading
    },
    isError() {
      return this.data.length === 0 && this.warehouseFetcher?.error
    },
    cannotFindWarehouse() {
      return this.searchWarehouse && this.filteredData?.length === 0
    },
  },
  created() {
    this.debouncedFetchWarehouse = _.debounce(async search => {
      await this.searchWarehouseFn(search)
    }, 500)
  },
  methods: {
    /**
     * Handle the card click event
     * @param {Object} data - the warehouse data
     */
    handleCardClick(data) {
      this.selectedWarehouse = data
      this.$emit('select', data)
    },
    /**
     * Check if the warehouse is selected
     * @param {Object} data - the warehouse data
     * @returns {Boolean} - true if the warehouse is selected, false otherwise
     */
    checkIsSelected(data) {
      return this.selectedWarehouse?.warehouse_id === data.warehouse_id
    },
    /**
     * Check if the warehouse is disabled
     * @param {Object} data - the warehouse data
     * @returns {Boolean} - true if the warehouse is disabled, false otherwise
     */
    checkIsDisabled(data) {
      return this.usedWarehouses?.some(warehouse => warehouse.warehouse_id === data.warehouse_id)
    },
    /**
     * Generate the key for the warehouse
     * @param {Object} data - the warehouse data
     * @param {Number} index - the index of the warehouse
     * @returns {String} - the key for the warehouse
     */
    generateKey(data, index) {
      return `${data.warehouse_id}-${index}`
    },
    /**
     * Handle the search warehouse input event
     * @param {Event} event - the input event
     */
    async handleSearchWarehouse(event) {
      const search = event || ''
      await this.debouncedFetchWarehouse(search)
    },
    /**
     * Handle the search warehouse data function
     * @param {String} search - the search query
     */
    async searchWarehouseFn(search) {
      if (!search) {
        this.searchWarehouse = ''
        this.filteredData = undefined
        return
      }

      if (this.warehouseFetcher?.hasMore) {
        await this.warehouseFetcher.fetchData()

        this.searchWarehouseFn(search)
        return
      }

      const searchResult = this.data.filter(warehouse => warehouse?.warehouse_name?.toLowerCase().includes(search.toLowerCase()))
      if (searchResult.length > 0) {
        this.filteredData = searchResult

        return
      }

      this.searchWarehouse = search
      this.filteredData = []
    },
  },
}
</script>
